import { sharedCareScoutQuestions, MEDICAL_DETAILS_TITLE_OVERRIDE } from './careScoutAppSharedQuestions';
import { sharedCareScoutSections } from './careScoutAppSharedSections';

const questions: Record<string, PolicyFormQuestion> = {
  ...sharedCareScoutQuestions,
  premiumAmount: {
    id: 'premium-amount',
    questionRef: 'premiumAmount',
    title: 'What is your annual premium rate?',
    type: 'text',
    required: true,
    validationType: 'currency',
  },
  coverageMaximumSpecial: {
    id: 'coverage-maximum',
    questionRef: 'coverageMaximumSpecial',
    title: 'Coverage Maximum',
    type: 'radio',
    required: true,
    options: [
      { id: '50000', value: '$50,000' },
      { id: '100000', value: '$100,000' },
      { id: '150000', value: '$150,000' },
      { id: '200000', value: '$200,000' },
      { id: '250000', value: '$250,000' },
    ],
  },
  dailyBenefitAmount50k: {
    id: 'daily-benefit-amount-50k',
    questionRef: 'dailyBenefitAmount50k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '50000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '50000',
      },
    },
  },
  dailyBenefitAmount100k: {
    id: 'daily-benefit-amount-100k',
    questionRef: 'dailyBenefitAmount100k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '100000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '100000',
      },
    },
  },
  dailyBenefitAmount150k: {
    id: 'daily-benefit-amount-150k',
    questionRef: 'dailyBenefitAmount150k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '150000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '150000',
      },
    },
  },

  dailyBenefitAmount200k: {
    id: 'daily-benefit-amount-200k',
    questionRef: 'dailyBenefitAmount200k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '200000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '200000',
      },
    },
  },

  dailyBenefitAmount250k: {
    id: 'daily-benefit-amount-250k',
    questionRef: 'dailyBenefitAmount250k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '250000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '250000',
      },
    },
  },

  aidsOrArc: {
    id: 'aids-or-arc',
    questionRef: 'aidsOrArc',
    title:
      'Have you ever been diagnosed by a member of the medical profession as having: Acquired Immune Deficiency Syndrome (AIDS) or AIDS Related Complex (ARC)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  aidsOrArcDetails: {
    id: 'aids-or-arc-details',
    questionRef: 'aidsOrArcDetails',
    title:
      'Acquired Immune Deficiency Syndrome (AIDS) or AIDS Related Complex (ARC) Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'aidsOrArc',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'aidsOrArc',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  advisedByMedicalProfession: {
    id: 'advised-by-medical-profession',
    questionRef: 'advisedByMedicalProfession',
    title:
      'Do you expect to have any medical tests or procedures performed within the next 6 months?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  advisedByMedicalProfessionDetails: {
    id: 'advised-by-medical-profession-details',
    questionRef: 'advisedByMedicalProfessionDetails',
    title:
      'Expect to have any medical tests or procedures performed within the next 6 months details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'advisedByMedicalProfession',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'advisedByMedicalProfession',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  disabilityBenefits: {
    id: 'disability-benefits',
    questionRef: 'disabilityBenefits',
    title: 'Have you requested or received:',
    type: 'radio',
    required: false,
    options: [
      { id: 'workers-comp', value: "Worker's Compensation" },
      { id: 'other-disability', value: 'Other Disability Income' },
    ],
  },
};

export const careScoutAZFormDefinition: PolicyFormDefinition = {
  sections: [
    {
      id: 'coverage-selection',
      title: 'Coverage Selection',
      subsections: [
        {
          id: 'coverage-selection-questions',
          title: 'Coverage Selection',
          questionGroups: [
            {
              id: 'info-group',
              format: 'grid',
              questions: ['applicantName', 'applicantDob'],
            },
            {
              id: 'coverage-maximum-group',
              format: 'default',
              questions: [
                'coverageMaximumSpecial',
                'dailyBenefitAmount50k',
                'dailyBenefitAmount100k',
                'dailyBenefitAmount150k',
                'dailyBenefitAmount200k',
                'dailyBenefitAmount250k',
                'deductiblePeriod',
                'waiverOfHomeAndCommunityCare',
                'nonforfeitureBenefit',
                'inflationProtection',
              ],
            },
            {
              id: 'couple-status-group',
              format: 'default',
              questions: ['coupleStatus'],
            },
            {
              id: 'couple-status-related-group',
              format: 'default',
              questions: ['spouseName', 'spouseSsn', 'spouseDob', 'spouseCoverageNumber'],
              conditional: {
                visible: {
                  field: 'coupleStatus',
                  operator: 'equals',
                  value: 'yes',
                },
              },
            },
          ],
        },
        {
          id: 'coverage-selection-premium-info',
          title: 'Premium Information',
          questionGroups: [
            {
              id: 'premium-info-group',
              format: 'default',
              questions: ['premiumPaymentMode'],
            },
            {
              id: 'premium-agent-group',
              format: 'default',
              questions: [
                'agentName',
                'haveAgentProducerCode',
                'agentProducerCode',
                'nationalProducerCode',
                'applicationSignedState',
              ],
            },
          ],
        },
      ],
    },
    sharedCareScoutSections.eftPaymentAuth,
    sharedCareScoutSections.applicantProfile,
    sharedCareScoutSections.insurabilityProfile,
    {
      id: 'medical-questions',
      title: 'Medical Questions',
      subsections: [
        {
          id: 'primary-care-provider',
          title: 'Primary Care Provider',
          questionGroups: [
            {
              id: 'provider-info',
              format: 'default',
              questions: ['primaryCareProviderName'],
            },
            {
              id: 'provider-details',
              format: 'default',
              questions: ['primaryCareProviderAddress', 'primaryCareProviderPhone'],
            },
            {
              id: 'provider-visit',
              format: 'grid',
              questions: ['primaryCareProviderDateLastSeen', 'primaryCareProviderReasonLastSeen'],
            },
          ],
        },
        {
          id: 'physical-measurements',
          title: 'Physical Measurements',
          questionGroups: [
            {
              id: 'height-weight',
              format: 'grid',
              questions: ['heightFeet', 'heightInches', 'weight'],
            },
            {
              id: 'weight-change',
              format: 'default',
              questions: ['weightChange'],
            },
            {
              id: 'weight-change-details',
              format: 'grid',
              questions: ['weightChangeType', 'weightChangePounds', 'weightChangeRegimen'],
            },
          ],
        },
        {
          id: 'medical-conditions-cardiovascular',
          title: 'Medical Questions',
          questionGroups: [
            {
              id: 'heart-conditions-1',
              title: ' ',
              description:
                'Have you ever been diagnosed or advised by a member of the medical profession as having, or in the last 5 years been treated for any of the following conditions:',
              format: 'default',
              questions: [
                'anginaChestPains',
                'anginaChestPainsDetails',
                'heartAttack',
                'heartAttackDetails',
                'heartDisease',
                'heartDiseaseDetails',
                'heartMurmur',
                'heartMurmurDetails',
                'highBloodPressure',
                'highBloodPressureDetails',
                'irregularHeartbeat',
                'irregularHeartbeatDetails',
                'peripheralVascular',
                'peripheralVascularDetails',
              ],
            },
            {
              id: 'digestive-conditions-1',
              format: 'default',
              questions: [
                'colitisCrohns',
                'colitisCrohnsDetails',
                'esophagusDisorder',
                'esophagusDisorderDetails',
                'hepatitis',
                'hepatitisDetails',
                'intestinalDisorder',
                'intestinalDisorderDetails',
                'liverDisorder',
                'liverDisorderDetails',
                'pancreatitis',
                'pancreatitisDetails',
                'stomachDisorder',
                'stomachDisorderDetails',
                'weightLossProcedure',
                'weightLossProcedureDetails',
              ],
            },
            {
              id: 'metabolic-conditions',
              format: 'default',
              questions: [
                'diabetes',
                'diabetesDetails',
                'cancer',
                'cancerDetails',
                'leukemiaLymphoma',
                'leukemiaLymphomaDetails',
                'tumorMassLump',
                'tumorMassLumpDetails',
              ],
            },
            {
              id: 'respiratory-conditions',
              format: 'default',
              questions: [
                'asthma',
                'asthmaDetails',
                'chronicLungDisorder',
                'chronicLungDisorderDetails',
                'sleepApnea',
                'sleepApneaDetails',
              ],
            },
            {
              id: 'blood-vision-conditions',
              format: 'default',
              questions: [
                'bloodDisorder',
                'bloodDisorderDetails',
                'macularDegeneration',
                'macularDegenerationDetails',
              ],
            },
            {
              id: 'mental-conditions',
              format: 'default',
              questions: [
                'bipolarDisorder',
                'bipolarDisorderDetails',
                'depression',
                'depressionDetails',
                'otherMentalDisorder',
                'otherMentalDisorderDetails',
              ],
            },
            {
              id: 'urological-conditions',
              format: 'default',
              questions: [
                'bladderDisorder',
                'bladderDisorderDetails',
                'kidneyDisorder',
                'kidneyDisorderDetails',
                'prostateDisorder',
                'prostateDisorderDetails',
              ],
            },
            {
              id: 'musculoskeletal-conditions-1',
              format: 'default',
              questions: [
                'amputation',
                'amputationDetails',
                'arthritis',
                'arthritisDetails',
                'backSpineNeck',
                'backSpineNeckDetails',
                'boneJointMuscle',
                'boneJointMuscleDetails',
                'osteoporosis',
                'osteoporosisDetails',
              ],
            },
            {
              id: 'neurological-conditions-1',
              format: 'default',
              questions: [
                'memoryLoss',
                'memoryLossDetails',
                'brainNervousSystem',
                'brainNervousSystemDetails',
                'injuryFalls',
                'injuryFallsDetails',
                'paralysis',
                'paralysisDetails',
                'tremors',
                'tremorsDetails',
                'postPolioSyndrome',
                'postPolioSyndromeDetails',
                'seizuresConvulsions',
                'seizuresConvulsionsDetails',
                'strokeTia',
                'strokeTiaDetails',
              ],
            },
            {
              id: 'other-conditions',
              format: 'default',
              questions: [
                'lupusScleroderma',
                'lupusSclerodermaDetails',
                'organTransplant',
                'organTransplantDetails',
                'otherCripplingConditions',
                'otherCripplingConditionsDetails',
              ],
            },
            {
              id: 'medications',
              format: 'default',
              questions: [
                'aidsOrArc',
                'aidsOrArcDetails',
                'additionalPrescriptionMedications',
                'medicationDetails',
                'advisedByMedicalProfession',
                'advisedByMedicalProfessionDetails',
                'upcomingMedicalTests',
              ],
            },
            {
              id: 'past-medical-care',
              format: 'default',
              questions: [
                'hospitalPatient',
                'hospitalPatientDetails',
                'otherTreatment',
                'otherTreatmentDetails',
                'incompleteTests',
                'incompleteTestsDetails',
                'assistanceRequired',
                'assistanceRequiredDetails',
                'receivedHomeCare',
                'receivedHomeCareDetails',
              ],
            },
            {
              id: 'disability-info',
              format: 'default',
              questions: [
                'disabilityBenefits',
                'disabilityDescription',
                'disabilityFromDate',
                'disabilityToDate',
              ],
            },
          ],
        },
      ],
    },
    sharedCareScoutSections.socialHistory,
    sharedCareScoutSections.familyHistory,
    sharedCareScoutSections.otherCoverage,
    sharedCareScoutSections.protectionLapse,
    sharedCareScoutSections.producerSignature,
    sharedCareScoutSections.ltcAppOverflowForm,
    sharedCareScoutSections.healthInsuranceAuthorization,
    sharedCareScoutSections.ltcInsurancePersonalWorksheet,
    sharedCareScoutSections.verificationFinancialNonDisclosure,
    sharedCareScoutSections.ltcPotentialRateIncreaseDisclosure,
    sharedCareScoutSections.licensedInsuranceProducerInformation,
  ],
  questions,
};
